import setAssetPrefix from "routing/SetAssetPrefix";
setAssetPrefix("/assets/");
